import React, { Component } from 'react'
import dynamic from 'next/dynamic'

import { componentLoader } from '../../helpers'

const LottieAnimationComponent = dynamic(
  () =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "@components/LottieAnimationComponent" */ './LottieAnimation.component'
        ),
    ),
  { loading: () => null },
)

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static defaultProps = {
    fallback: null,
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    const { hasError } = this.state
    const { children, fallback } = this.props
    return hasError ? fallback : children
  }
}

const LottieAnimation = ({ fallback, ...props }) => (
  <ErrorBoundary fallback={fallback}>
    <LottieAnimationComponent {...props} />
  </ErrorBoundary>
)
LottieAnimation.defaultProps = { fallback: null }

export default LottieAnimation
